import {useContext} from 'react';
import Modal from 'react-bootstrap/Modal';
import { ButtonPrimary } from '../../../common/components';
import { useEffect } from 'react';
import { TagManager } from '../../utils/analytics/TagManager';
import { UserDetailContext, UserDetailContextProps } from '../../../context/userDetail/userDetailContext';

type HHDataRequestFailureModalProps = {
  meterType: Common.IOption;
  onHide: () => void;
  show: boolean;
};

const defaultProps = {
  show: true,
};

export const HHDataRequestFailureModal = (props: HHDataRequestFailureModalProps) => {
  const { userDetail } = useContext<UserDetailContextProps>(UserDetailContext);
  const { show } = props;
  const convertMeterTypeToText = (meterType: string) => {
    switch (meterType) {
      case 'HalfHourly':
        return 'HH';
      case 'Smart':
        return 'Smart meter';
      case 'AutomaticMeterRead':
        return 'AMR';
      default:
        return meterType;
    }
  };

  const title = `${convertMeterTypeToText(props.meterType.value)} data request failure`;

  useEffect(() => {
    if (show) {
      TagManager.pushData({
        event: 'HH data request failure',
        customerAccountReference: userDetail.essCustomerId
      });
    }
  }, [show]);

  const handleClose = (event: any) => {
    event.preventDefault();
    props.onHide();
  };

  return (
    <>
      <Modal animation={false} className={'custom-modal'} show={show} backdrop='static' centered>
        <Modal.Header style={{ justifyContent: 'center', textAlign: 'center' }}>
          <Modal.Title>{title}</Modal.Title>
        </Modal.Header>
        <Modal.Body style={{ justifyContent: 'center', textAlign: 'center' }}>
          <p>Unfortunately we can't process your request at this time.</p>
          <p>Please try again later.</p>
        </Modal.Body>
        <Modal.Footer className='p-0'>
          <ButtonPrimary onClick={handleClose} title='OK' className='mt-3 mr-0' />
        </Modal.Footer>
      </Modal>
    </>
  );
};

HHDataRequestFailureModal.defaultProps = defaultProps;
